import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Addmetal_purity_karat.css";
import { createMetalPurityCarat } from "../../../../services/metal_purity_karat/metal_purity_karat.service";
import { getAllDesired } from "../../../../services/DesiredType/DesiredType.service";
import { toast } from "react-toastify";

interface MetalType {
  id: number;
  name: string;
}

const AddMetalPurityCarat: React.FC = () => {
  const navigate = useNavigate();

  const [metalTypes, setMetalTypes] = useState<MetalType[]>([]);
  const [metalTypeId, setMetalTypeId] = useState("");

  const [karat, setKarat] = useState("");
  const [purity, setPurity] = useState("");
  const [carat, setCarat] = useState("");
  const [centValue, setCentValue] = useState("");

  const selectedMetal = metalTypes.find(
    (m) => m.id === Number(metalTypeId)
  );

  const metalName = selectedMetal?.name?.toLowerCase() || "";

  const isGold = metalName.includes("gold");
  const isDiamond = metalName.includes("diamond");
  const isSilver = metalName.includes("silver");

  useEffect(() => {
    const fetchMetalTypes = async () => {
      try {
        const res = await getAllDesired();
        setMetalTypes(res.data || res);
      } catch (error) {
        toast.error("Failed to load metal types");
      }
    };

    fetchMetalTypes();
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!metalTypeId) {
      toast.error("Metal Type is required");
      return;
    }

    try {
      await createMetalPurityCarat({
        metalTypeId: Number(metalTypeId),

        karat: isGold ? karat : null,

        purity:
          (isGold || isSilver) && purity
            ? Number(purity)
            : null,

        carat:
          isDiamond && carat
            ? Number(carat)
            : null,

        centValue:
          isDiamond && centValue
            ? Number(centValue)
            : null,
      });

      toast.success("Metal Purity created successfully");
      navigate("/metal-type-purity/list");
    } catch (error) {
      toast.error("Failed to create record");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-card">
        <div className="modal-header">
          <h2>Add Metal Purity / Carat</h2>
          <span className="close-btn" onClick={() => navigate(-1)}>
            ✕
          </span>
        </div>

        <form onSubmit={handleSubmit}>
          <label>Metal Type *</label>
          <select
            className="custom-select"
            value={metalTypeId}
            onChange={(e) => {
              setMetalTypeId(e.target.value);
              setKarat("");
              setPurity("");
              setCarat("");
              setCentValue("");
            }}
          >
            <option value="">Select Metal Type</option>
            {metalTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>

          {/* GOLD */}
          {isGold && (
            <>
              <label>Karat</label>
              <input
                type="text"
                value={karat}
                onChange={(e) => setKarat(e.target.value)}
                placeholder="Enter Karat (e.g. 24K)"
              />

              <label>Purity (%)</label>
              <input
                type="number"
                value={purity}
                onChange={(e) => setPurity(e.target.value)}
                placeholder="Enter Purity"
              />
            </>
          )}

          {/* DIAMOND */}
          {isDiamond && (
            <>
              <label>Carat</label>
              <input
                type="number"
                value={carat}
                onChange={(e) => setCarat(e.target.value)}
                placeholder="Enter Carat"
              />

              <label>Cent Value</label>
              <input
                type="number"
                value={centValue}
                onChange={(e) => setCentValue(e.target.value)}
                placeholder="Enter Cent Value"
              />
            </>
          )}

          {/* SILVER */}
          {isSilver && (
            <>
              <label>Purity (%)</label>
              <input
                type="number"
                value={purity}
                onChange={(e) => setPurity(e.target.value)}
                placeholder="Enter Purity"
              />
            </>
          )}

          <div className="modal-actions">
            <button
              type="button"
              className="cancel-btn"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>

            <button type="submit" className="add-btn">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddMetalPurityCarat;
